const TYPES = [
  'Journal Entry',
  'Seller Payment',
  'Expense',
  'Bill Payment',
  'Vendor Credit',
  'Purchase Order',
  'Fee',
  'Fee Estimate',
  'Invoice',
  'Payment',
  'Deposit',
  'Void',
  'Credit Memo',
  'Fee Invoice',
];

export default TYPES;
